import React, { Component } from 'react';
import { history } from '../../component/helpers/history';
import { withTranslation } from 'react-i18next';
class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            GamePageurl: ['lucky1-1d', 'rush3-3d', 'dream5-5d', 'magic5-5d', 'fortune6-6d', 'super6-6d',
                'lottery-ticket-lucky1', 'lottery-ticket-rush3', 'lottery-ticket-dream5', 'lottery-ticket-magic5', 'lottery-ticket-fortune6', 'lottery-ticket-super6'
                , 'home', '', 'lucky1', 'rush3', 'dream5', 'magic5', 'fortune6', 'super6', 'big-ticket'
            ],
            GameurlFlag: false
        }
    }
    changeTab = (tabid) => {
        localStorage.setItem('tabId', tabid);
        history.push('/generalinfo');
    }

    componentDidMount() {
        let checkUrl = this.state.GamePageurl.filter(a => a == this.props.Pageloc);
        if (checkUrl && checkUrl.length > 0) {
            this.setState({ GameurlFlag: true })
            this.state.GameurlFlag = true;
        }
        else {
            this.setState({ GameurlFlag: false })
            this.state.GameurlFlag = false;
        }
    }
    render() {
        const { t } = this.props;
        return (
            <footer class="foot-margin">
                <div class="footCent">
                    <div class="newsLetter">
                        <div class="footLogo">
                            <img src="./assets/img/foot-logo.png" />
                        </div>
                        <span>{t('lblnewsletter')}</span>
                        <p>{t('lblsubsnews')}</p>
                        <div class="mail">
                            <input type="text" placeholder={t("lblEnterEmailId")} />
                            <button>{t('lblsend')}</button>
                        </div>
                    </div>

                    <div class="quickLinks">
                        <a onClick={() => this.changeTab(1)}>{t('lblAbout')}</a>
                        <a onClick={() => this.changeTab(9)}>{t('lblParticipateResponsible')}</a>
                        <a onClick={() => this.changeTab(11)}>{t('lblGamesRules')}</a>
                        <a >{t('lblwinnersec')}</a>
                        <a onClick={() => history.push('/Privacy')}>{t('lblPrivacyFooter')}</a>
                        <a onClick={() => history.push('/plyerkyc')}>{t("lblkycpage")}</a>
                    </div>

                    <div class="quickLinks">
                        <a onClick={() => this.changeTab(12)}>{t('lblContactus')}</a>
                        <a onClick={() => this.changeTab(13)}>{t('lblFeedback')}</a>
                        <a onClick={() => this.changeTab(15)}>{t('lblnewsletter')}</a>
                        <a onClick={() => this.changeTab(6)}>{t('lblLegal')}</a>
                        <a onClick={() => this.changeTab(4)}>{t('lblTermsandCondition')}</a>
                        <a onClick={() => history.push('/SupportMatrix')}>{t('lblSupportMatrix')}</a>

                    </div>
                    <div class="support">
                        <div class="social">
                            <span>{t('lblflwus')}</span>
                            <a ><img src="./assets/img/icons/insta.png" /></a>
                            <a ><img src="./assets/img/icons/facebook.png" /></a>
                            <a ><img src="./assets/img/icons/youtube.png" /></a>
                            <a ><img src="./assets/img/icons/x.png" /></a>
                        </div>
                        <div class="supportCont">
                            <a ><img src="./assets/img/icons/support.png" />xxx xxxxxxxxx</a>
                            <a ><img src="./assets/img/icons/mail.png" />helpdesk@gulfticket.com</a>
                            <div class="footApp">
                                <span>{t('lblmobileapp')}</span>
                                <a ><img src="./assets/img/icons/foot-apple.png" />iOS App</a>
                                <a ><img src="./assets/img/icons/foot-android.png" />Android App</a>
                            </div>
                        </div>
                    </div>
                </div>


                {/* <div class="footCent">
                    <div class="newsLetter">
                        <span>Newsletter</span>
                        <p>Subscribe to the newsletter and stay up to date</p>
                        <div class="mail">
                            <input type="text" placeholder="Enter your email id" />
                            <button>Send</button>
                        </div>
                    </div>
                    <div class="quickLinks">
                        <a >{t('lblAbout')}</a>
                        <a >{t('lblParticipateResponsible')}</a>
                        <a onClick={() => this.changeTab(11)}>{t('lblGamesRules')}</a>
                        <a >{t('lblwinnersec')}</a>
                    </div>
                    <div class="quickLinks">
                        <a >{t('lblContactus')}</a>
                        <a >{t('lblFeedback')}</a>
                    </div>
                    <div class="support">
                        <a ><img src="./assets/img/icons/support.png" />xxx xxxxxxxxx</a>
                        <a ><img src="./assets/img/icons/mail.png" />helpdesk@gulfticket.com</a>
                        <div class="footApp">
                            <span>Mobile Apps</span>
                            <a ><img src="./assets/img/icons/foot-apple.png" />iOS App</a>
                            <a ><img src="./assets/img/icons/foot-android.png" />Android App</a>
                        </div>
                    </div>
                </div> */}
                <div class="footBtom">
                    <p>© 2025 {t('lblGulfTicket')}. {t('lblAllRightReserved')}.</p>
                    <p>{t('lblfooterinfo')}</p>
                </div>
            </footer>
        );
    }
}
export default (withTranslation()(Footer));